import { render } from "./StoryPage.vue?vue&type=template&id=dcb3758c&scoped=true"
import script from "./StoryPage.vue?vue&type=script&lang=js"
export * from "./StoryPage.vue?vue&type=script&lang=js"

import "./StoryPage.vue?vue&type=style&index=0&id=dcb3758c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcb3758c"]])

export default __exports__